var _g, _g2, _g3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAddproduct({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "g2502"
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "g2504"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path2506",
    d: "M2.92969 8.15625L10 10.5L17.0703 8.15625L11.7578 6.39844",
    stroke: "currentColor",
    strokeWidth: 1.2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "g2508"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Clip path group"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_9899_5497",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 21
  }, _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "clipPath2514"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path2512",
    d: "M0 0.500002H20V20.5H0V0.500002Z",
    fill: "white"
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_9899_5497)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g2510"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g2516"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path2518",
    d: "M17.0703 12.8438V17.5703L10 19.9141L2.92969 17.5703V12.8438",
    stroke: "currentColor",
    strokeWidth: 1.2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g2520"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path2522",
    d: "M10 19.9141V10.5L7.65625 14.0156L0.585938 11.6719L2.92969 8.15625L8.24219 6.39844",
    stroke: "currentColor",
    strokeWidth: 1.2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g2524"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path2526",
    d: "M10 10.5L12.3437 14.0156L19.4141 11.6719L17.0703 8.15625",
    stroke: "currentColor",
    strokeWidth: 1.2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g2528"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path2530",
    d: "M11.1719 4.64063V1.08594H8.82812V4.64063H6.48438L10 8.15625L13.5156 4.64063H11.1719Z",
    stroke: "currentColor",
    strokeWidth: 1.2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddproduct);
export default __webpack_public_path__ + "static/media/addproduct.c143f963de591d80c299568470ece169.svg";
export { ForwardRef as ReactComponent };